import type ts from 'typescript';

import type { EvaluateResponse, Evaluator } from '../types';

const evaluatePropertyAccessExpression: Evaluator<ts.PropertyAccessExpression> = ({
  node,
  variables,
  log,
  evaluators,
}) => {
  const expression = evaluators.expression({
    evaluators,
    log,
    node: node.expression,
    variables,
  });

  if (node.name.text === 'length') {
    if (Array.isArray(expression) || typeof expression === 'string') {
      return expression.length;
    }
    return 0;
  }

  if (
    expression === null ||
    expression === undefined ||
    typeof expression !== 'object' ||
    expression instanceof Error
  ) {
    return undefined;
  }

  // don't strictly check the type of the accessor, just let javascript try.
  return (expression as Record<string, EvaluateResponse>)[node.name.text];
};

export default evaluatePropertyAccessExpression;
